import React, { useState } from "react";
import { Box, Typography, Stack, Checkbox } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { EmailInput, PasswordInput } from "../UIElements/inputs";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { loginSchema } from "../../validate/authentication";

import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { apiSignIn } from "../../api/auth";
import { useNotificationService } from "../notification";
import OptCodeDetails from "./OtpCode";
import { PATH_AUTH } from "../../routes/path";
import { Link } from "react-router-dom";

//
const LoginDetails: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();
  const [open_otp, setOpen_otp] = useState(true);
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  // const { set_data } = useAuth();

  const {
    register,
    formState: { errors },
    reset,
    handleSubmit,
  } = useForm({
    resolver: zodResolver(loginSchema),
  });
  // set up react query mutation
  const mutation = useMutation({
    mutationFn: apiSignIn,
    onSuccess: (data) => {
      // Handle error
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
      }
      //  Handle success
      if ("data" in data) {
        showNotification(data?.data?.message ?? "Successful", "success");
        setOpen_otp(false);
      }
    },
    onError: (error) => {
      console.error("Process failed", error);
      // Handle error
      showNotification("Process failed", "error");
    },
  });
  const onSubmitHandler = async (values: any): Promise<void> => {
    const { email, password } = values;
    setData({ email: email, password: password });

    const data_report = { password: password, email: email, otp: "" };
    mutation.mutate(data_report);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {open_otp ? (
        <Box
          component="form"
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit(onSubmitHandler)}
        >
          <EmailInput
            labelText="Email"
            errors={errors}
            placeholder="Enter email"
            register={register}
          />
          <PasswordInput
            labelText="Password"
            errors={errors}
            placeholder="Enter password"
            register={register}
          />
          <Stack direction="row" alignItems={"center"}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Checkbox />
              <Typography
                sx={{
                  color: theme.palette.text.secondary,
                  fontFamily: "Lexend",
                  fontSize: "15px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  letterSpacing: "-0.23999999463558197px",
                }}
              >
                Remember me
              </Typography>
            </Box>
            <Link
              style={{
                color: theme.palette.text.secondary,
                marginLeft: "auto",
                textDecorationLine: "none",
              }}
              to={PATH_AUTH.resetPassword}
            >
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Lexend",
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "18x",
                }}
              >
                Forgot Password?
              </Typography>
            </Link>
          </Stack>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            sx={{ my: 3 }}
          >
            <LoadingButton
              loading={mutation.isPending}
              type="submit"
              variant="contained"
              sx={{
                width: "100%",
                borderRadius: "12px",
                fontFamily: "DM Sans",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "19.84px",
              }}
            >
              Sign in
            </LoadingButton>
          </Stack>
        </Box>
      ) : (
        <OptCodeDetails
          openOtp={open_otp}
          data={data}
          setOpenOtp={setOpen_otp}
        />
      )}
    </Box>
  );
};

export default LoginDetails;
